var app = angular.module('leonardo');

var ReadMore = function($filter, $timeout, $compile) {
  return {
    restrict: 'AC',
    scope: true,
    link: function (scope, element, attrs, ctrls) {
      scope.read_text = $filter('translate')('Read more');
      scope.init = false;
      scope.active = false;
      scope.element = element;

      scope.getRealHeight = function () {
        let height = 0;
        scope.element.children().each(function () {
          if (!$(this).hasClass('read-more-icon')) {
            height += $(this).height();
          }
        });
        return height;
      }

      scope.cropHeight = function () {
        let height = scope.getRealHeight();
        if (height > 60 && !scope.element.hasClass('read-more')) {
          scope.element.append($compile('<span class="read-more-icon" ng-click="expand()" color="primaryColor">{{ read_text }}</span>')(scope));
          scope.element.addClass('read-more');
          scope.element.animate({height: 40}, 500);
        }
        else {
          scope.element.find('.read-more-icon').each(function () {
            $(this).remove();
          });
          scope.element.removeClass('read-more');
          scope.element.css('height', '');
        }
      }

      scope.expand = function () {
        scope.active = true;
        if (scope.element.hasClass('active')) {
          let height = scope.getRealHeight();
          if (height > 60) {
            scope.element.animate({height: 40});
            scope.read_text = $filter('translate')('Read more');
          }
          else {
            scope.cropHeight();
          }
        }
        else {
          scope.element.animate({height: scope.getRealHeight() + 20});
          scope.read_text = $filter('translate')('Read less');
        }
        scope.element.toggleClass('active');
        $timeout(function () {
          scope.active = false;
        }, 500)
      };

      $timeout(function () {
        if (!scope.init) {
          scope.cropHeight();
          scope.init = true;
        }
      }, 100);

      angular.element(scope.element).resize(function(){
        if (!scope.active) {
          scope.cropHeight();
        }
      });
    }
  };
};

app.directive('readMore', ['$filter', '$timeout', '$compile', ReadMore]);
